import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OrgLogoModalComponent} from './org-logo-modal.component';
import {FormsModule} from "@angular/forms";
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {ImageUploadModule} from "../../lib/image-upload/image-upload.module";
import { ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [OrgLogoModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    AlertMessageModule,
    ImageUploadModule,
    ButtonModule
  ],
  exports: [OrgLogoModalComponent]
})
export class OrgLogoModalModule {
}
